import React from "react";
import { ArrowRight } from "lucide-react";
import NexusLogo from "../core/NexusLogo";
import { modules } from "../../constants";

const ModulesPage = ({ onNavigate }) => {
  return (
    <div className="max-w-6xl mx-auto p-6">
      <div className="flex items-center mb-10">
        <NexusLogo className="w-16 h-16 mr-4" />
        <h1 className="text-3xl font-bold text-gray-900">
          Nexus Platform Modules
        </h1>
      </div>

      <p className="text-xl text-gray-600 mb-12">
        Our comprehensive solution includes these powerful modules to ensure a
        seamless Workday migration.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
        {modules.map((module) => (
          <div
            key={module.id}
            className="border border-gray-200 rounded-lg p-6 hover:shadow-lg transition-all 
                      hover:border-blue-300 hover:bg-blue-50 cursor-pointer"
            onClick={() =>
              module.id === "discovery" ? onNavigate("discovery") : null
            }
          >
            <div className="rounded-full bg-gray-100 w-12 h-12 flex items-center justify-center mb-4">
              {module.icon}
            </div>
            <h3 className="text-xl font-semibold mb-2 text-gray-800">
              {module.title}
            </h3>
            <p className="text-gray-600">{module.description}</p>

            {module.id === "discovery" && (
              <div className="mt-4 text-blue-600 font-medium flex items-center">
                <span>Explore Module</span>
                <ArrowRight size={16} className="ml-1" />
              </div>
            )}
          </div>
        ))}
      </div>

      <div className="text-center">
        <button
          type="button"
          onClick={() => onNavigate("discovery")}
          className="px-6 py-3 bg-blue-600 text-white rounded-lg font-medium 
                    hover:bg-blue-700 transition-colors shadow-md"
        >
          Next: Discovery Dashboard
        </button>
      </div>
    </div>
  );
};

export default ModulesPage;
